// import { useEffect, useState } from "react";
// import { fetchState, fetchRegionandTerritory } from "../../../api/locationApi"; 
// import MantisDataTable from "../../../components/common/MantisDataTable";
// import { useNavigate } from "react-router";

// export default function RegionList() {
//   const navigate = useNavigate();
//   const [stateList, setStateList] = useState([]);
//   const [region, setRegion] = useState([]);
//   const [filters, setFilters] = useState({ stateDesc: "" });
//   const [loading, setLoading] = useState(false);

//   // Load states on mount
//   useEffect(() => {
//     const loadStates = async () => {
//       const states = await fetchState();
//       setStateList(states || []);
//     };
//     loadStates();
//   }, []);

//   // Handle filter changes
//   const handleFilterChange = (updatedFilters) => {
//     setFilters(updatedFilters);
//   };

//   // Handle filter submit
//   // const handleFilterSubmit = async () => {
//   //   if (!filters.stateDesc) {
//   //     setRegion([]);
//   //     return;
//   //   }
//   //   setLoading(true);
//   //   try {
//   //     // Pass description instead of code
//   //     const data = await fetchRegionandTerritory(filters.stateDesc, "REGION");
//   //     setRegion(data);
//   //   } catch (err) {
//   //     console.error("Error fetching region data:", err);
//   //     setRegion([]);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   const handleFilterSubmit = async () => {
//   setLoading(true);

//   try {
//     const stateValue = filters.stateDesc === "ALL" ? "All" : filters.stateDesc;


//     const data = await fetchRegionandTerritory(stateValue, "REGION");
//     setRegion(data || []);
//   } catch (err) {
//     console.error("Error fetching region data:", err);
//     setRegion([]);
//   } finally {
//     setLoading(false);
//   }
// };

//    const handleEdit = (region) => {
//     navigate("/add-region", { state: { region } });
//   };

//   const handleAdd = () => {
//     navigate("/add-region", { state: { region } });
//   };

//   return (
//     <div className="space-y-6">
//       <MantisDataTable
//         title="Region Master"
//         data={region}
//         loading={loading}
//         columns={[
//         // {
//         //     label: "Action",
//         //     key: "action",
//         //     type: "actions",
//         //     actions: [
//         //         {
//         //         type: "edit",
//         //         label: "View Details",
//         //         action: handleEdit,
//         //         },
//         //     ],
//         //   },
//           { key: "code", label: "Code" },
//           { key: "name", label: "Name" },
//           { key: "status", label: "Status", type: "badge" },
//         ]}
//         searchable
//         searchPlaceholder="Search by name/code"
//         onFilterChange={handleFilterChange}
//         onFilterSubmit={handleFilterSubmit}
//         showAddButton
//         onAdd={handleAdd}
//             filters={[
//         {
//           name: "stateDesc",
//           label: "State",
//           type: "select",
//           options: [
//             { label: "All", value: "ALL" },
//             ...stateList.map((s) => ({
//               value: s.description,
//               label: s.description,
//             })),
//           ],
//         },
//       ]}
//       />
//     </div>
//   );
// }



// RegionList.jsx
import { useEffect, useState } from "react";
import { fetchState, fetchRegionandTerritory } from "../../../api/locationApi";
import MantisDataTable from "../../../components/common/MantisDataTable";
import { useNavigate } from "react-router";

export default function RegionList() {
  const navigate = useNavigate();
  const [stateList, setStateList] = useState([]);
  const [region, setRegion] = useState([]);
  const [filters, setFilters] = useState({ stateDesc: "ALL" });
  const [loading, setLoading] = useState(false);

  // Load states + initial fetch
  useEffect(() => {
    const init = async () => {
      const states = await fetchState();
      setStateList(states || []);
      fetchData("All"); // 🔥 auto load all
    };
    init();
  }, []);

  const fetchData = async (stateValue) => {
    setLoading(true);
    try {
      const data = await fetchRegionandTerritory(stateValue, "REGION");
      setRegion(data || []);
    } catch (err) {
      console.error("Error fetching region data:", err);
      setRegion([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (updatedFilters) => {
    setFilters(updatedFilters);

    const stateValue =
      updatedFilters.stateDesc === "ALL" ? "All" : updatedFilters.stateDesc;

    fetchData(stateValue); // 🔥 auto fetch
  };

  const handleEdit = (region) => {
    navigate("/add-region", { state: { region } });
  };

  const handleAdd = () => {
    navigate("/add-region");
  };

  return (
    <div className="space-y-6">
      <MantisDataTable
        title="Region Master"
        data={region}
        loading={loading}
        columns={[
          { key: "code", label: "Code" },
          { key: "name", label: "Name" },
          { key: "status", label: "Status", type: "badge" },
        ]}
        searchable
        searchPlaceholder="Search by name/code"
        onFilterChange={handleFilterChange}
        filters={[
          {
            name: "stateDesc",
            label: "State",
            type: "select",
            options: [
              { label: "All", value: "ALL" },
              ...stateList.map((s) => ({
                value: s.description,
                label: s.description,
              })),
            ],
          },
        ]}
        showAddButton
        onAdd={handleAdd}
      />
    </div>
  );
}
